import { useEffect } from 'react'

import { trackOnboardingStepFailed } from '@/utils/analytics'

export default function KycRedirectFailed() {
  useEffect(() => {
    trackOnboardingStepFailed(
      'external_kyc_redirect',
      'sumsub_verification_failed'
    )
    const params = new URLSearchParams(window.location.search)
    params.set('kyc_status', 'failed')
    const signupKycUrl = `${window.location.protocol}//${window.location.hostname}/SignupKYC?${params.toString()}`
    window.location.replace(signupKycUrl)
  }, [])

  const params = new URLSearchParams(window.location.search)
  params.set('kyc_status', 'failed')
  const signupKycUrl = `${window.location.protocol}//${window.location.hostname}/SignupKYC?${params.toString()}`

  return (
    <div data-testid="container-kyc-redirect-failed">
      <span data-testid="text-kyc-redirect-failed-message">
        Redirecting to Paytrie. If you are not redirected automatically, click
        here:{' '}
      </span>
      <a
        style={{ textDecoration: 'underline' }}
        href={signupKycUrl}
        data-testid="link-kyc-redirect-failed-manual"
      >
        {signupKycUrl}
      </a>
    </div>
  )
}
